<!--
  @HelpButton  Toggles the help panel; placed at the right end of the module navigation bar.
  Long press or right click opens the documentation update (admins only).
-->

<script>
		import {user, view} from "../client.svelte.js";
		import NavButton from "./NavButton.svelte";

		let longpressTimer, longpressTriggered = false

		function toggle_help() {
				if (longpressTriggered) {
						longpressTriggered = false
						return
				}
				if (view.help)
					view.turnoff_help()
				else
					view.turnon_help()
		}

		function update_docs(e) {
				e.preventDefault()
				if (!['Pierre', 'Natalie', 'Martin', 'Florian'].includes(user.ID))  return
				view.show_dialog('updatedocs', {})
		}

		function start_longpress(e) {
				longpressTriggered = false
				longpressTimer = setTimeout(() => {
						longpressTriggered = true
						update_docs(e)
				}, 800)
		}

		const cancel_longpress = () => clearTimeout(longpressTimer)
</script>


<NavButton icon="circle-question" label="Hilfe" title="Hilfe (F1)" active={!!view.help} data-help="helpbutton"
           onclick={toggle_help} oncontextmenu={update_docs}
           onpointerdown={start_longpress} onpointerup={cancel_longpress} onpointerleave={cancel_longpress} />
